import { DomainEvent } from "../model/domain-event.model";

export class ServiceWorkerChangedEvent implements DomainEvent {
  readonly occurredAt = new Date();

  constructor() {}
}